const conditionClassModifier = (condition) =>
  condition ? condition.toLowerCase().replace(/_/g, '-') : 'lola';

export default conditionClassModifier;
